import { gql } from '@apollo/client';

export default gql`
  fragment RefundsProduct on Product {
    itemRef
    associatedItemRefs
    passengerId
    isAFareAddOn
    price: priceWithCurrency(currency: $currency)
    loyaltyPoints
    tariffDetails {
      tariffCode
    }
    code
    currency
    inventoryClass
    name
    cancelled
    provisional
    canBeRebooked
    canBeCancelled
    canBeRefunded
    afterSalesRules {
      active
      validUntil
      price
      type
      currentActive
    }
    passenger {
      id
      type
      firstName
      lastName
      email
      phoneNumber
      birthDate
      loyaltyNumber
      disabilityType
    }
    productFamily {
      code
      name
      familyGroup
    }
  }
`;
